class AuthorBiography {
    /**
     * A Model representing the author biography text for the current book.
     * @param {object} authorBioData The author bio data to be used
     */
    constructor(authorBioData){
        this.id = authorBioData.ID;
        this.name = authorBioData.AuthorName;
        this.body = authorBioData.Biography;
        this.featureType = '';
    }   
}

export default AuthorBiography;


// WEBPACK FOOTER //
// ./src/models/AuthorBiography.js